// Datentypen der Kapazitäts-Balken — eigene Datei statt Export aus capacity-bars.component,
// damit Modelle (z. B. technician-tour.model) sie ohne Komponenten-Import nutzen können

// Ansicht der Kapazitätsübersicht: Tages-Balken oder 2-Wochen-Grid
export type CapacityView = 'day' | 'grid'

// localStorage-Schlüssel für den geteilten Techniker-Gruppenfilter
// (Dashboard-Kapazitätsbalken ↔ Kapazitätsübersichts-Seite), damit beide
// dieselben Techniker anzeigen
export const TECHNICIAN_GROUP_FILTER_STORAGE_KEY = 'dashboardTechnicianGroupFilter'

export interface BarData {
  description: string
  values: BarDataValue[]
  start_at_unit_amount: number
  style: 'filled' | 'bordered'
  filter_attributes: string[]
  options: {
    'Reisetechniker'?: boolean
  },
  external_idx?: number
  utilizationPercent?: number
  // Abwesenheitsgrund des Tages (aus Absence.io), z.B. 'Urlaub' — nur gesetzt,
  // wenn der Techniker an dem Tag abwesend ist
  absence_reason?: string
}

export interface BarDataValue {
  color: string,
  unit_amount: number,
  tooltip: BarTooltip,
  icon?: 'loading_error' | 'finished' | 'home_travel' | null,
  style?: 'filled' | 'bordered' // Per-Segment Style-Override (überschreibt Bar-Style)
}

export interface BarOption {
  title: string,
  tooltip: string
}

export interface Deadline {
  at_value: number,
  description: string,
  color: string
}

export interface BarTooltip {
  infos: string[],
  errors: string[]
}
